<!--  -->
<template>
	<div class="carBg">
		<!-- 上侧 -->
		<div class="point1">
			<div class="inner flex flex-direction">
				<div class="location">
					<i class="el-icon-location-outline margin-right-5"></i>{{ stationName }} 
				</div>
				<div class="line"></div>
				<div class="ecInfo flex justify-around">
					<div class="circleMove" id="circleMove">
						<div class=" circleInner flex flex-direction justify-center">
							<div class="DS-font text-30 green-text text-center">{{ ChargeNum }}</div>
							<!-- 日换电次数 -->
							<div style="white-space: nowrap;">当天换电次数</div>
						</div>
					</div>
					<div class="flex flex-direction align-center">
						<div>空闲中电池</div>
						<div class="text-xxl-xl DS-font green-text">
							{{ battery.freeBatteryNum || 0 }}
						</div>
					</div>
					<div class="flex flex-direction align-center">
						<div>充电中电池</div>
						<div class="text-xxl-xl DS-font green-text">
							{{ battery.chargingBatteryNum || 0 }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 底部 -->
		<div class="point2">
			<div class="inner"></div>
			<div class="flex justify-around">
				<div class="ecQuantity flex flex-direction align-center">
					<div class="ecQuantityText">当天换电时长(h)</div>
					<div class="ecQuantityCounts DS-font text-xl" style="margin-top: 15px">
						{{ changeDatteryTime || 0 }}
					</div>
					<!-- <div class="ecQuantityPie">
						<CirclePie :cdata="cdata1" :height="'70'" :width="'70'" />
					</div> -->
				</div>
				<div class="ecQuantity flex flex-direction align-center">
					<div class="ecQuantityText">当天电量(kWh)</div>
					<div class="ecQuantityCounts DS-font text-xl" style="margin-top: 15px">
						{{ sameElectricQuantity || 0 }}
					</div>
					<!-- <div class="ecQuantityPie">
						<CirclePie :cdata="cdata2" :height="'70'" :width="'70'" />
					</div> -->
				</div>
			</div>
		</div>
		<!-- 中间 -->
		<!-- <div class="point3 flex justify-center" @click="jumpToBatteryHolder">
			<img src="@/assets/images/site/arrow_small.png" />进入充电仓
		</div> -->
	</div>
</template>

<script>
import CirclePie from "@/components/echart/circlePie";
// import { siteLeft } from '@/api/singleSite/left';
import { dataInterface } from "@/api/dataInterfaceApi";
let ProgressBar = require("progressbar.js");

export default {
	name: "home",
	components: {
		CirclePie,
	},
	data() {
		return {
			// cdata1: {
			// 	text: "",
			// 	series: [{
			// 		name: "访问来源",
			// 		type: "pie",
			// 		radius: ["50%", "70%"],
			// 		center: ["50%", "50%"],
			// 		data: [{
			// 				value: 0,
			// 				itemStyle: {
			// 					color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
			// 							offset: 0,
			// 							color: "#62DBFF"
			// 						},
			// 						{
			// 							offset: 1,
			// 							color: "#3D8DFF"
			// 						},
			// 					]),
			// 				},
			// 			},
			// 			{
			// 				value: 0,
			// 				itemStyle: {
			// 					opacity: 0.2,
			// 					color: "#fff",
			// 				},
			// 			},
			// 		],
			// 		labelLine: {
			// 			show: false,
			// 		},
			// 	}, ],
			// },
			// cdata2: {
			// 	text: "",
			// 	series: [{
			// 		name: "访问来源",
			// 		type: "pie",
			// 		radius: ["50%", "70%"],
			// 		center: ["50%", "50%"],
			// 		data: [{
			// 				value: 0,
			// 				itemStyle: {
			// 					color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
			// 							offset: 0,
			// 							color: "#62DBFF"
			// 						},
			// 						{
			// 							offset: 1,
			// 							color: "#4FFF3D"
			// 						},
			// 					]),
			// 				},
			// 			},
			// 			{
			// 				value: 0,
			// 				itemStyle: {
			// 					opacity: 0.2,
			// 					color: "#fff",
			// 				},
			// 			},
			// 		],
			// 		labelLine: {
			// 			show: false,
			// 		},
			// 	}, ],
			// },
			info: {
				changePowerNum: 0
			},
			changeDatteryTime: "",
			sameElectricQuantity: "",
			ChargeNum: "",
			battery: {
				freeBatteryNum: "",
				chargingBatteryNum: ""
			},
			stationId: '',
			stationName: ''
		};
	},
    inject: ['stationObj'],
    computed: {
        computedProperty() {
            return this.stationObj()
        }
    },
    watch: {
        computedProperty(val) {
            this.stationId = val.value
			this.stationName = val.name
			this.init()
        },
    },
	mounted() {
		// let val = this.stationObj()

		// this.stationId = val.value
		// this.stationName = val.name
		
		// this.init()
	},
	methods: {
		init() {
			// 站点-当天换电次数
			this.dayhuandiancishu()
			// 站点-中间-空闲中充电中电池数量
			this.kongxianchongdiandianchi()
			// 站点-中间-当天换电时长
			this.todayhdsc()
			// 站点-中间-当天换电量
			this.todaydl()
		},
		// 站点-当天换电次数
		dayhuandiancishu() {
			let _this = this
			dataInterface
				.dataFaceApi({
					enCode: "TiDB-Energy-zhandian-dayhuandiancishu",
					"@station_id": _this.stationId,
				})
				.then((res) => {
					if (!res) return
					res = res[0] || {}
					_this.ChargeNum = res.ChargeNum;
				})
				.catch((err) => {
					console.log(err);
				})
		},
		// 站点-中间-空闲中充电中电池数量
		kongxianchongdiandianchi() {
			let _this = this;
			dataInterface
				.dataFaceApi({
					enCode: "TiDB-Energy-zhandian-kongxianchongdiandianchi",
					"@station_id": _this.stationId,
				})
				.then((res) => {
					if (!res) return
					let data = res[0] || {}
					_this.battery.freeBatteryNum = data.freeBatteryNum
					_this.battery.chargingBatteryNum = data.chargingBatteryNum
				})
				.catch((err) => {
					console.log(err)
				});
		},
		// 站点-中间-当天换电时长
		todayhdsc() {
			let _this = this;
			dataInterface
				.dataFaceApi({
					enCode: "TiDB-Energy-zhandian-todayhdsc",
					"@station_id": _this.stationId,
				})
				.then((res) => {
					if (!res) return
					let data = res[0] || {}
					_this.changeDatteryTime = data.ChargeTime
					_this.sameElectricQuantity = data.ChargeNum
				})
				.catch((err) => {
					console.log(err)
				});
		},
		// 站点-中间-当天换电量
		todaydl() {
			let _this = this;
			dataInterface
				.dataFaceApi({
					enCode: "TiDB-Energy-zhandian-todaydl",
					"@station_id": _this.stationId,
				})
				.then((res) => {
					if (!res) return
					let data = res[0] || {}
					_this.changeDatteryTime = data.ChargeTime
					_this.sameElectricQuantity = data.ChargeNum
				})
				.catch((err) => {
					console.log(err)
				});
		},
		// 跳转到电池仓页面
		jumpToBatteryHolder() {
			return
			//query-路由传参
			// batteryHolder?stationId=29cf1372-5bc1-4127-9a51-e260f3749ad3&batteryId=1000290070
			if (this.$route.query && this.$route.query.stationId) {
				let stationId = this.$route.query.stationId;
				let batteryId = sessionStorage.getItem("batteryId");
				let chargingWarehouseNumber = sessionStorage.getItem(
					"chargingWarehouseNumber"
				);
				if (window.location.href.indexOf("pcsingleSite") > -1) {
					this.$router.push({
						path: "/pcbatteryHolder",
						query: {
							stationId: stationId,
							batteryId: batteryId,
							chargingWarehouseNumber: chargingWarehouseNumber,
						},
					});
				} else {
					this.$router.push({
						path: "/batteryHolder",
						query: {
							stationId: stationId,
							batteryId: batteryId,
							chargingWarehouseNumber: chargingWarehouseNumber,
						},
					});
				}
			} else {
				console.log("暂无站点");
			}
		},
	},
};

function playLoop(bar) {
	var start =
		arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	var interval = void 0;
	var playing = false;

	function animateBar() {
		bar.animate(1, function() {
			setTimeout(function() {
				bar.animate(0);
			}, 500);
		});
	}

	function resume() {
		if (playing) {
			return;
		}
		playing = true;
		interval = setInterval(function() {
			bar.set(0);
			animateBar();
		}, 4e3);
		animateBar();
	}
	if (start) {
		resume();
	}
	return {
		pause: function pause() {
			if (interval) {
				bar.stop();
				clearInterval(interval);
			}
			playing = false;
		},
		resume: resume,
	};
}
</script>
<style lang="scss" scoped>
$green-text: #49fff9;

.green-text {
	color: $green-text;
}

.carBg {
	width: 1600px;
	height: 660px;
	position: relative;
	transform: translate(5%, -10%);
	background: url("~@/assets/images/site/car.png");
	background-size: 100% 100%;
	font-size: 14px;
}

.circleMove {
	position: relative;
	width: 105px;
	height: 105px;
	// border:6px solid $green-text;
	border-radius: 50%;

	.circleInner {
		width: 90px;
		height: 90px;
		position: absolute;
		background: url("~@/assets/images/site/circle_icon.png");
		background-size: 100% 100%;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
}

.ecInfo {
	width: 100%;
	height: 100%;
	padding: 30px 20px 0;
	align-items: center;
}

.location {
	margin: 16px auto 12px ;
	justify-content: start;
	display: flex;
	width: 331px;
	align-items: center;
	height: 20px;
	// > i {
	// 	height: 12px;
	// }
}

.line {
	width: 331px;
	height: 1px;
	/*no*/
	background: #3dbcc1;
	margin: 0 auto;
}

.point1,
.point2,
.point3 {
	position: absolute;
}

.point1 {
	width: 496px;
	height: 284px;
	background: url("~@/assets/images/site/point1.png");
	background-size: 100% 100%;
	top: -23%;
    right: 20%;
	font-size: 20px;
	.inner {
		position: absolute;
		width: 396px;
		height: 188px;
		left: 100px;
	}
}

.point2 {
	min-width: 340px;
	min-height: 146px;
	background-image: linear-gradient(180deg,
			rgba(14, 134, 139, 0.88) 3%,
			rgba(0, 43, 41, 0.6) 100%);
	border: 1px solid #1a7683;
	bottom: 4%;
    left: 0%;
	padding: 12px 15px;

	.inner {
		width: 94px;
		height: 132px;
		background: url("~@/assets/images/site/point.png");
		background-size: cover;
		position: absolute;
		top: -66px;
		right: -94px;
	}

	.ecQuantityText {
		background: rgb(106, 173, 172, 0.6);
		padding: 4px 9px;
		font-size: 20px;
	}

	.ecQuantityPie {
		width: 90px;
		height: 70px;
	}
}

.point3 {
	// width:138px;
	// height:40px;
	background: #00bab8;
	border-radius: 2px;
	font-size: 18px;
	font-weight: 500;
	padding: 8px 13px;
	top: 40%;
	left: 36%;
	cursor: pointer;

	img {
		width: 16px;
		height: 16px;
		margin-right: 5px;
		transform: rotate(180deg);
	}
}

.DS-font {
	font-family: "DS-Digital-Bold";
}
</style>